import styled from 'styled-components';
import { densityPaddingTokens, headerIconTitlePaddingTokens, headerTypographyTokens } from './Card.types';
import { useCardContext } from './CardContext';
import { Flex } from '../Flex/Flex';
import { Text } from '../Text/Text';
import { Spacer } from '../Spacer/Spacer';
import { ChevronIcon } from './ChevronIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledDisclosureTrigger = styled.button.withConfig({
  displayName: "CardHeader__StyledDisclosureTrigger",
  componentId: "sc-1ib3td4-0"
})(({
  as
}) => ({
  all: 'unset',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: as === 'button' ? 'pointer' : 'default'
}));
export const CardHeader = ({
  title,
  actions,
  density = 'normal',
  titleSize = 'medium'
}) => {
  const {
    isExpandable,
    isExpanded,
    triggerElementAriaAttributes,
    onToggle
  } = useCardContext();
  const paddingStyles = densityPaddingTokens['CardHeader'][density];
  const headerIconPaddingToken = headerIconTitlePaddingTokens[titleSize];
  const typographyToken = headerTypographyTokens[titleSize];
  return /*#__PURE__*/_jsxs(Flex, Object.assign({
    display: "inline-flex",
    justifyContent: "space-between",
    alignItems: "center",
    inlineSize: "100%",
    gap: "300"
  }, paddingStyles, {
    children: [/*#__PURE__*/_jsxs(StyledDisclosureTrigger, Object.assign({
      as: isExpandable ? 'button' : 'div'
    }, isExpandable ? triggerElementAriaAttributes : {}, {
      onClick: onToggle,
      children: [isExpandable && /*#__PURE__*/_jsx(ChevronIcon, {
        isExpanded: isExpanded
      }), isExpandable && /*#__PURE__*/_jsx(Spacer, {
        display: "inline-block",
        space: headerIconPaddingToken
      }), /*#__PURE__*/_jsx(Text, {
        typography: typographyToken,
        children: title
      })]
    })), actions && actions]
  }));
};